import {createComponent} from '../bridge/create-component';
import type {BridgeComponentOptions} from '../bridge/types';
import type {GooglePayProps} from './types';
import {config} from '../config';
import {containerTemplate} from '../container';
import {validateComponentProps} from '../utils';
import {getPaymentMethods} from '../api';

export * from './types';

const componentOptions: BridgeComponentOptions<GooglePayProps> = {
  tag: 'monei-google-pay',
  url: config.paymentRequestUrl,
  dimensions: {
    width: '100%',
    height: '0'
  },
  autoResize: {
    width: false,
    height: true
  },
  aliases: {
    style: 'innerStyle'
  },
  computedProps: {
    __getConfig: {
      factory: ({props}) => getPaymentMethods.bind(null, props),
      type: 'function'
    }
  },
  validate: validateComponentProps,
  containerTemplate
};

export const GooglePay = createComponent<GooglePayProps>(componentOptions);
